<template>
	<v-navigation-drawer
		v-model="drawer"
		temporary
		location="right"
	>
		<v-toolbar elevation="0" style="flex: 0 1 auto;">
			<v-avatar>
				<v-icon icon="mdi-cog"></v-icon>
			</v-avatar>
			<v-toolbar-title>Settings</v-toolbar-title>
			
			<v-spacer></v-spacer>

			<v-btn icon @click="drawer=false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-toolbar>

		<v-list>
			<v-list-subheader>Тема</v-list-subheader>
			<v-list-item
				prepend-icon="mdi-theme-light-dark"
				title="Light or dark"
			>
				<template v-slot:append>
					<v-switch 
						v-model="$vuetify.theme.global.name"
						false-value="light"
    					true-value="dark" 
					></v-switch>
				</template>
			</v-list-item>
		</v-list>

		<v-divider></v-divider>
		
		<v-list>
			<v-list-subheader>OS</v-list-subheader>
			<v-list-item
				:title="device.osName"
				:subtitle="device.osVersion"
			>
				<template v-slot:prepend>
					<v-icon v-if="device.osName=='iOS'" icon="mdi-apple-ios"></v-icon>
					<v-icon v-else-if="device.osName=='Android'" icon="mdi-android"></v-icon>
					<v-icon v-else-if="device.osName=='Windows Phone'" icon="mdi-microsoft-windows"></v-icon>
					<v-icon v-else-if="device.osName=='Windows'" icon="mdi-microsoft-windows-classic"></v-icon>
					<v-icon v-else icon="mdi-compass"></v-icon>
				</template>
			</v-list-item>
		</v-list>

		<v-list>
			<v-list-subheader>Browser</v-list-subheader>
			<v-list-item
				:title="device.browserName"
				:subtitle="device.browserMajorVersion +' ('+device.browserFullVersion+')'"
			>
				<template v-slot:prepend>
					<v-icon v-if="device.browserName=='Chrome'" icon="mdi-google-chrome"></v-icon>
					<v-icon v-else-if="device.browserName=='Firefox'" icon="mdi-firefox"></v-icon>
					<v-icon v-else-if="device.browserName=='Opera'" icon="mdi-opera"></v-icon>
					<v-icon v-else-if="device.browserName=='Safari'" icon="mdi-apple-safari"></v-icon>
					<v-icon v-else-if="device.browserName=='Internet Explorer'" icon="mdi-microsoft-internet-explorer"></v-icon>
					<v-icon v-else-if="device.browserName=='Edge'" icon="mdi-microsoft-edge"></v-icon>
					<!-- <v-icon v-else-if="device.browserName=='Chromium'" icon="mdi-microsoft-windows-classic"></v-icon> -->
					<!-- <v-icon v-else-if="device.browserName=='IE'" icon="mdi-microsoft-windows-classic"></v-icon>
					<v-icon v-else-if="device.browserName=='Mobile Safari'" icon="mdi-microsoft-windows-classic"></v-icon>
					<v-icon v-else-if="device.browserName=='Edge Chromium'" icon="mdi-microsoft-windows-classic"></v-icon> -->
					<v-icon v-else icon="mdi-web"></v-icon>
				</template>
			</v-list-item>
		</v-list>

		<v-divider></v-divider>

		


		<template v-slot:append>
			<v-list>
				<v-list-item
					title="Версія"
					:subtitle="version"
					prepend-icon="mdi-tag"
				></v-list-item>
			</v-list>
          <!-- <div class="pa-2">
            <v-btn block>
              Logout
            </v-btn>
          </div> -->
        </template>


		<!-- browserFullVersion
: 
"128.0.0.0"
browserMajorVersion
: 
"128"
browserName
: 
"Chrome"
engineName
: 
"WebKit"
engineVersion
: 
"537.36"
isBrowser
: 
true
osName
: 
"Windows"
osVersion
: 
"10"
userAgent
: 
"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/128.0.0.0 Safari/537.36"
[[Prototype]]
: 
Object -->

		<!-- <v-list>
			<v-list-subheader>Тема</v-list-subheader>
			<v-list-item
				prepend-icon="mdi-theme-light-dark"
				title="Light or dark"
			>
				<template v-slot:append>
					<v-switch 
						v-model="$vuetify.theme.global.name"
						false-value="light"
    					true-value="dark" 
					></v-switch>
				</template>
			</v-list-item>

			<v-list-item
				prepend-icon="mdi-palette"
				title="Палітра"
			>
				<template v-slot:append>
					<v-menu offset-y>
						<template v-slot:activator="{ props }">
							<v-btn small :color="theme?.color" dark v-bind="props">{{ $vuetify.theme.global.name }}</v-btn>
						</template>
						<v-list>
							<v-list-item v-for="(item, key) in $vuetify.theme.themes" :key="key"
								:title="$filters.capitalize(key)"
								:active="$vuetify.theme.global.name === key"
								@click="$vuetify.theme.global.name = key"
							>
								<template v-slot:append>
									<v-toolbar elevation="0" dense>
										<v-tooltip location="bottom" v-for="(color, name) in item.colors" >
											<template v-slot:activator="{ props }">
												<v-icon v-bind="props" :color="color" icon="mdi-square"></v-icon>
											</template>
											<span>{{ $filters.capitalize(name in $vuetify.locale.messages.en ? $vuetify.locale.t(`$vuetify.${name}`) : name) }}</span>
										</v-tooltip>
									</v-toolbar>
								</template>
							</v-list-item>
						</v-list>
					</v-menu>
				</template>

			</v-list-item>
		</v-list>

		<v-divider></v-divider>

		<v-list>
			<v-list-subheader>Сервер</v-list-subheader>
			<v-list-item
				prepend-icon="mdi-server"
				title="Режим"
			>
				<template v-slot:append>
					<v-menu offset-y>
						<template v-slot:activator="{ props }">
							<v-btn v-bind="props">{{ server.name }}</v-btn>
						</template>
						<v-list>
							<v-list-item v-for="(item, index) in servers" :key="index"
								:title="$filters.capitalize(item.title)"
								:active="server.name === item.name"
								@click="onServer(item)"
							></v-list-item>
						</v-list>
					</v-menu>
				</template>
			</v-list-item>
		</v-list> -->
		
	</v-navigation-drawer>

</template>

<script>
import { isMobile, osName, osVersion, deviceDetect } from 'mobile-device-detect';
//import axios from 'axios'
//import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'Settings',
	data: () => ({
		//colors: ["background","surface","primary","secondary","error","info","success","warning",]
	}),
	props: {
		modelValue:				{ type: Boolean, default: false }, //drawer
		//title:				{ type: String, default: 'settings' },
	},
	computed: {
		//...mapGetters([ 'theme', 'themes','server', 'servers' ]),
		drawer: {
			get() 		{ return this.modelValue },
			set(val) 	{ this.$emit('update:modelValue', val) }
		},

		version() {
			return process.env.VUE_APP_VERSION;
		},

		osName() 		{ return osName },
		osVersion() 	{ return osVersion },
		device() 		{ return deviceDetect() },

		/* osIcon() {
			console.log(this.$options.name, 'osIcon', 'device', this.device)

			let result = 'mdi-compass'
			switch(osName) {
				case "iOS": result = 'mdi-apple-ios'; break;
				case "Android": result = 'mdi-android'; break;
				case "Windows Phone": result = 'mdi-microsoft-windows'; break;
				case "Windows": result = 'mdi-microsoft-windows-classic'; break;
				//case "Mac OS": result = 'mdi-compass'; break;
			}
			return result
		}, */
	},
	methods: {
		/* ...mapActions([ 'setTheme', 'setServer' ]),

		onServer(item) {
			//console.log('settings.vue', 'methods', 'onServer', 'item', item)
			this.setServer(item)
			axios.defaults.baseURL = item.url;

			this.$emit('server')
			//console.log('settings.vue', 'methods', 'onServer', 'baseURL', axios.defaults.baseURL)
		}, */
	},
}

</script>